module.exports = __webpack_public_path__ + "static/media/x.42347c4d.svg";